import React from "react";
import { useTranslation } from "react-i18next";

import { ProjectCustomNotesForm } from "./Form";
import { useMe } from "../../../hooks/queries";
import { AccountType } from "../../../models/AccountData";
import { ProjectData } from "../../../models/ProjectData";


import "./styles.scss";


interface IProjectCustomNotesProps {
  project?: ProjectData;
}

export const ProjectCustomNotes: React.FunctionComponent<
  IProjectCustomNotesProps
> = (props) => {
  const { data: me } = useMe();
  const isAdmin = me?.type === AccountType.ADMIN;
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`projectManagementPage.projectCustomNotes.${key}`);
  return (
    <div className="white-border-panel project-custom-notes">
      <div className="project-custom-notes-container">
        <h2 className="project-custom-notes-title">{t("custom_notes")}</h2>
        {!!props.project && (
          <ProjectCustomNotesForm
            project={props.project}
            allowSubmit={isAdmin}
          />
        )}

      </div>
    </div>
  );
};
